module.exports = __webpack_public_path__ + "img/aboutus_1.007fadb4.png";